export default __webpack_public_path__ + "static/footer_logo-cc1c30939e199d04b53b44be672051f2.svg";